@if (stakingProcess$ | async; as stakingProcess) {
  <img src="assets/images/staking/success.png" [alt]="'success_alt_text' | translate" />
  <div class="title">
    <span>{{
      (stakingProcess.type === stakeType ? "staking_pending_title" : "unstaking_pending_title") | translate
    }}</span>
  </div>
  <span class="sub">
    {{
    (stakingProcess.type === stakeType ? "staking_pending_subtitle" : "unstaking_pending_subtitle")
    | translate
    : [
    stakingProcess.stakeable?.name,
    stakingProcess.amountType === tradeAmountTypes.ASSET
    ? (stakingProcess.amount
    | tradable_precision_symbol: { id: stakingProcess.stakeable?.id })
    : (stakingProcess.amount
    | fiat_precision_symbol
    : {
    id: defaultFiat?.getId(),
    currencies: [defaultFiat],
    symbol: true
    })
    ]
    }}
  </span>
}
